import React from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const FilterMenu = ({
  anchorEl,
  open,
  handleClose,
  filterState,
  setFilterState,
}) => {
  const handleChange = (event) => {
    const { name, value, checked, type } = event.target;
    setFilterState({
      ...filterState,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleDateChange = (name, date) => {
    setFilterState({
      ...filterState,
      [name]: date,
    });
  };

  const handleReset = () => {
    setFilterState({
      status: {
        paid: false,
        pending: false,
        draft: false,
      },
      dateRange: {
        from: null,
        to: null,
      },
      amountRange: {
        min: "",
        max: "",
      },
    });
  };

  const handleApply = () => {
    // Apply filter logic
    handleClose();
  };

  return (
    <Popover
      id={open ? "filter-menu-popover" : undefined}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ p: 3, width: 320 }}>
        <Typography variant="h6" gutterBottom>
          Filter Invoices
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Typography variant="subtitle2" gutterBottom>
          Status
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={filterState.status.paid}
                onChange={handleChange}
                name="status.paid"
              />
            }
            label="Paid"
          />
          <FormControlLabel
            control={
              <Switch
                checked={filterState.status.pending}
                onChange={handleChange}
                name="status.pending"
              />
            }
            label="Pending"
          />
          <FormControlLabel
            control={
              <Switch
                checked={filterState.status.draft}
                onChange={handleChange}
                name="status.draft"
              />
            }
            label="Draft"
          />
        </FormGroup>

        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
          Date Range
        </Typography>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <DatePicker
                label="From"
                value={filterState.dateRange.from}
                onChange={(date) => handleDateChange("dateRange.from", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    margin="normal"
                  />
                )}
              />
              <DatePicker
                label="To"
                value={filterState.dateRange.to}
                onChange={(date) => handleDateChange("dateRange.to", date)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    margin="normal"
                  />
                )}
              />
            </Box>
          </LocalizationProvider>
        </FormControl>

        <Typography variant="subtitle2" gutterBottom>
          Amount Range
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            label="Min"
            type="number"
            name="amountRange.min"
            value={filterState.amountRange.min}
            onChange={handleChange}
            size="small"
            InputProps={{
              startAdornment: "$",
            }}
            fullWidth
          />
          <TextField
            label="Max"
            type="number"
            name="amountRange.max"
            value={filterState.amountRange.max}
            onChange={handleChange}
            size="small"
            InputProps={{
              startAdornment: "$",
            }}
            fullWidth
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Button color="inherit" onClick={handleReset}>
            Reset
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleApply}
          >
            Apply Filters
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default FilterMenu; 